export default {

  setlocalStorage(key, value) {
    localStorage.setItem('syH5_' + key, value)
  },
  getlocalStorage(key) {
    return localStorage.getItem('syH5_' + key)
  },
  removelocalStorage(key) {
    localStorage.removeItem('syH5_' + key)
  },
  deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj))
  },
  jsonToForm(jsonObject){
    let arr = [];
    for (let item in jsonObject) {
      arr.push(encodeURIComponent(item) + "=" + encodeURIComponent(jsonObject[item]));
    }
    return arr.join('&');
  },
  formatProductList(list){
    if (list.length > 0) {
      let sortedProductList = [];
      let typeName = list[0].productType;
      let typeProductList = [];
      typeProductList.push(list[0]);
      let dto = {
        name: typeName,
        productList: typeProductList
      };
      sortedProductList.push(dto);
      for (let i = 1; i < list.length; i++) {
        for (let j = 0; j < sortedProductList.length; j++) {
          if (list[i].productType == sortedProductList[j].name) {
            typeProductList = sortedProductList[j].productList;
            typeProductList.push(list[i]);
            sortedProductList[j].productList = typeProductList;
            break;
          } else {
            if (j == sortedProductList.length - 1) {
              let typeName = list[i].productType;
              let typeProductList = [];
              typeProductList.push(list[i]);
              let dto = {
                name: typeName,
                productList: typeProductList
              };
              sortedProductList.push(dto);
              break;
            } else {
              continue;
            }
          }
        }
      }
      return sortedProductList;
    } else {
      return;
    }
  },
  getDateStr(num,space = '-',type = 'day') {
		var dd = new Date();
		dd.setDate(dd.getDate()+num);//获取num天后的日期
		var y = dd.getFullYear();
		var m = dd.getMonth()+1;//获取当前月份的日期
		var d = dd.getDate();
		var obj = {
			day:y+space+(m<10?'0'+m:m)+space+(d<10?'0'+d:d),
			month:y+space+(m<10?'0'+m:m),
			year:y
		}
		return obj[type];
	},
}



// WEBPACK FOOTER //
// ./src/util/common.js